export default __webpack_public_path__ + "static/media/GUA.1243b7ff.svg";